<template>
	<div class="reviewDetail mw1340">
		<el-header class="breadCrumbs">
			<el-breadcrumb separator="/">
				<i class="iconfont icon-home fl mr10"></i>
				<el-breadcrumb-item>智能审查</el-breadcrumb-item>
				<!-- <el-breadcrumb-item :to="{ path:"/result",query:{input:detailData.name,type:detailData.classify}}">检索结果页</el-breadcrumb-item> -->
				<!-- <el-breadcrumb-item :to="{ path:"/result",query:{input:"",type:100}}">检索结果页</el-breadcrumb-item> -->
				<el-breadcrumb-item :to="{ path: '/recordReview/reviewTaskManage'}">审查任务管理</el-breadcrumb-item>
				<el-breadcrumb-item>智能审查详情</el-breadcrumb-item>
			</el-breadcrumb>
		</el-header>
		<el-header class="switch">
			<div class="switchCon clearfix">
				<!-- <changeFontSize></changeFontSize> -->
				<el-menu :default-active="activeIndex" class="el-menu-demo-reviewDetail" mode="horizontal" @select="handleSelect" :router="true">
					<el-menu-item index="/recordReview/recordReview" v-if="reviewStage=='checking'">智能审查</el-menu-item>
					<el-menu-item index="/recordReview/generateReport" v-if="reviewStage=='report'">报告审阅</el-menu-item>
					<!-- <el-menu-item index="/recordReview/reviewFile">审查文件</el-menu-item> -->
					<el-menu-item index="/recordReview/reviewReport" v-if="reviewStage=='report'||reviewStage=='done'||reviewStage=='task'">审查报告</el-menu-item>
					<el-menu-item index="/recordReview/reviewOpinion">审查意见</el-menu-item>
					<!-- <el-menu-item index="/recordReview/reviewHistory">审查历史</el-menu-item> -->
				</el-menu>
			</div>
		</el-header>
		<router-view></router-view>
		<!-- <el-aside width="200px">Aside</el-aside>
		<el-main class="reviewDetail">
			
		</el-main>
		<el-aside width="200px">Aside</el-aside> -->
	</div>
</template>
<script>
//修改字号
// import changeFontSize from "../../changeFontSize.vue";

export default {
    components: {
		// changeFontSize,
	},
	data() {
		return {
			activeIndex:"",//当前激活导航
			reviewStage:"",//审查进度 智能审查 "checking"  生成报告 "report" 完成审查 "done"
      };
    },
    created() {
		this.reviewStage=window.localStorage.getItem("reviewStage");//审查进度 
		if(this.reviewStage=="checking"){
			this.activeIndex="/recordReview/recordReview";//智能审查
		}else if(this.reviewStage=="report"){
			this.activeIndex="/recordReview/generateReport";//生成报告
		}

		//跳转之后 横向导航高亮
		// this.activeIndex=this.$route.path;
		// 刷新后能高亮显示
		if(this.$route.path.indexOf('/recordReview/recordReview')>0){//智能审查
			this.activeIndex="/recordReview/recordReview";
		}
		else if(this.$route.path.indexOf('/recordReview/generateReport')>0){ //生成报告
			this.activeIndex="/recordReview/generateReport";
		}
		else if(this.$route.path.indexOf('/recordReview/reviewFile')>0){ //审查文件
			this.activeIndex="/recordReview/reviewFile";
		}
		else if(this.$route.path.indexOf('/recordReview/reviewReport')>0){//审查报告
			this.activeIndex="/recordReview/reviewReport";
		}
		else if(this.$route.path.indexOf('/recordReview/reviewOpinion')>0){ //审查意见
			this.activeIndex="/recordReview/reviewOpinion";
		}
		else if(this.$route.path.indexOf('/recordReview/reviewHistory')>0){//审查历史
			this.activeIndex="/recordReview/reviewHistory";
		}
		else{
			this.activeIndex=this.$route.path;
		}
	 },
	 watch:{
		$route(to,from){
			console.log(from);
			if(from.path.indexOf('recordReview')>0){
				this.$router.push("/refresh"); //刷新为了跟左侧导航一致
			}
		}
	},
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
		},
    }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/mixin.scss"; //定义方法
//切换
.switch {
	padding:0;
	height: 57px !important;

	background:transparent;
	.switchCon{
		height: 52px !important;
		background-color: $cfff;
		box-shadow: 1px 2px 4px 0px rgba(140, 153, 162, 0.09);
	}
}
.el-menu-demo-reviewDetail{
	width: 60%;
	border-bottom:none;
	&>.el-menu-item{
		line-height: 52px;
		height: 52px;
		position: relative;
		color:$c999;
		// font-weight:bold;
		@include fontSize($fz16, $num);
		&.is-active{
			// border-bottom: 2px solid #4f66d0;
			// color: #1246b6;
			@include themeBorderBottomColor(2px,solid);
			@include themeFontColor();
		}
		&:after{
			content: "";
			width: 1px;
			height: 14px;
			background: $cc9c9c9;
			position: absolute;
			right: 0;
			top: 20px;
			z-index:2;
		}
		&:last-child:after{
			display:none;
		}
	}
}
.el-container{
	width: 100%;
}
.reviewDetail{
	min-height: calc(100vh - 84px - 44px);
}
</style>